export const ADDRESS_CHICAGO = '8700 West Bryn Mawr, Suite 1200S Chicago, IL 60631-3512';
export const PHONE_CHICAGO = '847-297-7800';

export const ADDRESS_DC = '555 12th Street, NW, Suite 550 Washington, D.C. 20004-1200';
export const PHONE_DC = '202-828-7100';
